import { CheckCircleOutlined } from "@ant-design/icons";
import {
  Alert,
  App,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  QRCode,
  Row,
  Select,
  Space,
} from "antd";
import ECard from "../../components/ECard";
import ETable from "../../components/ETable";
import ETag from "../../components/ETag";
import { ColoredStatistic, Curl, ISO8601 } from "../../components/Jarvis";

import { useState } from "react";
import { Link } from "react-router-dom";
import InlineCopyable from "../../components/InlineCopyable";
export default function TerminalPage() {
  const [url, setURL] = useState("https://www.payplusinc.com/");
  const { notification } = App.useApp();
  const [forceUpdate, setForceUpdate] = useState(1);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    Curl.post("/payplus/gateway/resources/payments", values)
      .then((res) => {
        if ("page_url" in res.payload) {
          setURL(res.payload.page_url);
        }
        setForceUpdate((c) => c + 1);
        form.resetFields();
        setLoading(false);
        notification.success({
          message: "Payment Created",
          description:
            "You can now copy the QRCode or the one-time payable URL and send to your customer to start receiving payments.",
        });
      })
      .catch((err) => {
        console.log(err);
        if ("error" in err.payload) {
          notification.error({
            message: "Error",
            description: err.payload.error.message,
          });
        }
        setLoading(false);
      });
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <ECard title={"Payment Terminal"}>
          <Space direction="vertical">
            <Alert
              type="info"
              showIcon
              message="Create a one-time payable URL for your customers without doing any kind of integration, just send them the link to start receiving payments."
            />
            <Form
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              colon={false}
              onFinish={handleSubmit}
            >
              <Form.Item
                required
                label="Order Reference"
                name={["order", "reference"]}
                extra={
                  "Unique Order Reference, most of the time should be your system Order ID/Number"
                }
                rules={[
                  { required: true, message: "Order Reference is required" },
                  { type: "string", min: 1, max: 128 },
                ]}
              >
                <Input autoFocus />
              </Form.Item>
              <Form.Item
                required
                label="Order Currency"
                name={["order", "currency"]}
                rules={[{ required: true }]}
              >
                <Select
                  //   defaultValue={"NZD"}
                  options={[
                    { value: "NZD", label: "NZD - New Zealand Dollar" },
                  ]}
                />
              </Form.Item>
              <Form.Item
                required
                label="Order Amount"
                name={["order", "amount"]}
                rules={[{ required: true }, { type: "number", min: 1 }]}
              >
                <InputNumber />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  offset: 8,
                }}
              >
                <Button
                  type="primary"
                  icon={<CheckCircleOutlined />}
                  htmlType="submit"
                  loading={loading}
                >
                  Create
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </ECard>
      </Col>
      <Col span={12}>
        <ECard title={"Payment Terminal"}>
          <Space direction="vertical">
            <Alert
              type="info"
              showIcon
              message="by creating a Payment on the left, your payable URL will appears below."
            />
            <QRCode value={url} />
            <InlineCopyable>{url}</InlineCopyable>
          </Space>
        </ECard>
      </Col>
      <Col span={24}>
        <ECard title="Payments">
          <ETable
            forceUpdate={forceUpdate}
            name={["terminal", "payments"]}
            uri={`/payplus/gateway/resources/payments`}
            columns={[
              {
                title: "Reference",
                render: (item) => {
                  return (
                    <Link to={`/payments/${item.id}`}>
                      {item.order_reference}
                    </Link>
                  );
                },
              },
              {
                title: "Date",
                align: "center",
                render: (item) => {
                  return ISO8601(item.created_at);
                },
              },
              {
                title: "Status",
                align: "center",
                render: (item) => {
                  return <ETag>{item.status}</ETag>;
                },
              },
              {
                title: "Order",
                align: "right",
                render: (item) => {
                  return (
                    <ColoredStatistic
                      prefix={item.order_currency}
                      value={item.order_amount}
                    />
                  );
                },
              },
            ]}
          />
        </ECard>
      </Col>
    </Row>
  );
}
